import { render, staticRenderFns } from "./PendingBlock.vue?vue&type=template&id=50a820fe&scoped=true"
import script from "./PendingBlock.vue?vue&type=script&lang=js"
export * from "./PendingBlock.vue?vue&type=script&lang=js"
import style0 from "./PendingBlock.vue?vue&type=style&index=0&id=50a820fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a820fe",
  null
  
)

export default component.exports